import script from "./BaseLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseLoader.vue?vue&type=script&setup=true&lang=js"

import "./BaseLoader.vue?vue&type=style&index=0&id=4fe6bdd8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fe6bdd8"]])

export default __exports__